import casinoConfig from '@dcentralexpedientedigital/config';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

const userStore = new WebStorageStateStore({ store: window.localStorage });
const authRedirectUri = window.location.origin + '/auth/login.html';
const silentRedirectUri = window.location.origin + '/auth/silent-renew.html';

class CustomUserManager extends UserManager {
    processSignIn(url: string) {
        return this._signinEnd(url);
    }
}

export const userManager = new CustomUserManager({
    ...casinoConfig.authConfig,
    redirect_uri: authRedirectUri,
    silent_redirect_uri: silentRedirectUri,
    userStore,
    monitorSession: true,
});
